export const isModalFixEnabled = () => {
  return document.kvConfig?.enableModalFix === true;
};
